export default __webpack_public_path__ + "static/media/juegosemanas_ganar.9fafca10.png";